/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsPopupDiscount = {
  init: function ($section) {
    
    // Add settings from schema to current object
    window.PXUTheme.jsPopupDiscount = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    const cookieEnabled = this.popup_days_to_hide != 0 ? true : false; 
    const cookieValueDiscount = Cookies.get('discount_code');
    const cookieValue = Cookies.get(`popupDiscount--${cookieValueDiscount}`);

    if (cookieEnabled && cookieValue == 'opened') {
      return false;
    } else if (cookieValueDiscount) {
      if(this.element.querySelector(`[data-popup-discount="${cookieValueDiscount}"]`)) {
        setTimeout(() => {
          this.open(`[data-popup-discount="${cookieValueDiscount}"]`);
          if (cookieEnabled) {
            Cookies.set(`popupDiscount--${cookieValueDiscount}`, 'opened', { expires: parseInt(this.popup_days_to_hide) });
          }
        }, this.popup_delay * 1000);
      }
    }
  },

  open: function($src) {
    $.fancybox.open({
      src: $src,
      type: 'inline',
      opts: {
        baseClass: 'popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: () => {
          // Remove previous slides (fix for theme editor)
          $('.popup-modal .fancybox-slide').empty();
        },
        afterShow: () => {
          // After content is loaded, attach event listener for custom close icon
          $(document).on('touchstart click', '.popup__close', () => {
            this.close();
          });
          $(document).on('touchstart click', '.popup__close_button', () => {
            this.close();
          });
        },
        beforeClose: () => {
          // Prevent duplicate triggers for close icon click
          $('.popup__close').off();
        }
      }
    });
  },
  close: function() {
    $.fancybox.close($(`[data-popup-discount]`));
  },
  showThemeEditorState() {
    return;
    $('.popup-section').addClass('is-fixed-top'); // Prevent scroll to bottom
    this.open();
  },
  blockSelect: function($section, blockId) {
    if (this.element.querySelector(`[data-block-id="${blockId}"]`)) {
      $('.popup-section').addClass('is-fixed-top');
      this.close();
      this.open(`[data-block-id="${blockId}"]`);
    } else {
    this.close();
    }
  },
  hideThemeEditorState() {
    $('.popup-section').removeClass('is-fixed-top');
    this.close();
  },
  unload: function ($section) {
    $.fancybox.destroy();
    $('.popup-modal .fancybox-slide').empty();
    $('.popup__close').off();
  }
}

/******/ })();